import countries from 'assets/countries.json';
import { IOption } from 'components/Select/type';
import { useGetAllowedDeliveryCountryOptions } from 'utils/hooks/useGetAllowedDeliveryCountryOptions';
import { SUPPORTED_LANGUAGES } from './AdditionalCartDetailsModal/constants';

export const useGetCompanyCardData = (data: any, t: any) => {
  const allowedDeliveryCountries = useGetAllowedDeliveryCountryOptions(
    data?.company_settings?.allowed_delivery_countries ?? null
  );
  const allowedDeliveryCountriesText =
    allowedDeliveryCountries.length > 0
      ? allowedDeliveryCountries.map((country) => country.label).join(', ')
      : '';

  const companyConfigurationLeftData = {
    Name: data?.name,
    'VAT number': data?.vat_number,
    'COC number': data?.coc_number,
    'Phone number': data?.phone_number,
    Website: data?.website,
    Email: data?.email,
  };

  const companyConfigurationRightData = {
    Street: data?.address?.street,
    'House number': data?.address?.house_number,
    'Zip code': data?.address?.zip_code,
    City: data?.address?.city,
    'Country code': data?.address?.country,
  };

  const additionalCartDetails = data?.company_settings?.additional_cart_details;
  const additionalCartDetailsCount = additionalCartDetails
    ? Object.keys(additionalCartDetails).length
    : 0;

  const supplierSettingsLeftData = {
    'Vat percentage': data?.company_settings?.vat_percentage,
    'Logyx Order ID prefix': data?.company_settings?.order_prefix,
    'Allowed delivery countries': allowedDeliveryCountriesText,
  };

  const supplierSettingsRightData = {
    Currency: data?.company_settings?.pricing_currency,
    'Gross price': data?.company_settings?.is_gross_visible
      ? t('Visible')
      : t('Hidden'),
    'Additional cart details':
      additionalCartDetailsCount > 0
        ? `${additionalCartDetailsCount}/${SUPPORTED_LANGUAGES.length} ${t(
            'configured'
          )}`
        : '',
  };

  const fixedExchangeRates = data?.company_settings?.fixed_exchange_rates;
  const fixedRatesCount = fixedExchangeRates
    ? Object.keys(fixedExchangeRates).length
    : 0;

  const buyerSettingsLeftData = {
    Currency: data?.company_settings?.display_currency,
    'Fixed exchange rates':
      fixedRatesCount > 0 ? `${fixedRatesCount} ${t('configured')}` : '-',
  };

  return {
    companyConfigurationLeftData,
    companyConfigurationRightData,
    supplierSettingsLeftData,
    supplierSettingsRightData,
    buyerSettingsLeftData,
  };
};

export const useGetCurrencyOptions = () => {
  // Extract unique currencies using a Map to avoid duplicates
  const uniqueCurrencies = new Map();

  countries.forEach((country: any) => {
    const currency = country.currency;
    if (currency && !uniqueCurrencies.has(currency.id)) {
      uniqueCurrencies.set(currency.id, currency);
    }
  });

  // Convert Map values to array and sort by currency name
  const currencyTypeOptions: IOption[] = Array.from(uniqueCurrencies.values())
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((currency) => ({
      value: currency.code,
      label: `${currency.name} (${currency.code})`,
      key: currency.id.toString(),
    }));

  return currencyTypeOptions;
};
